import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
    return {
        tickerWrap: {
            zIndex: '1',
            // position: 'absolute',
            bottom: '0',
            width: '100%',
            overflow: 'hidden',
            height: '4rem',
            backgroundColor: theme.palette.primary.main,
            paddingLeft: '100%',
            boxSizing: 'content-box',
            borderRadius: theme.custom.borderRadius,
        },
        uppercase: {
            textTransform: 'uppercase',
        },
        heightSmall: {
            height: '27px',
        },
        heightMedium: {
            height: '28px',
            [theme.breakpoints.up('xl')]: {
                height: '35px',
            },
        },
        fontSmall: {
            fontSize: '12px',
            '& p': {
                lineHeight: '15px',
                fontSize: '12px',
            },
        },
        fontMedium: {
            fontSize: '12px',
            '& p': {
                lineHeight: '28px',
                fontSize: '12px',
            },
            [theme.breakpoints.up('xl')]: {
                fontSize: '14px',
                '& p': {
                    lineHeight: '35px',
                    fontSize: '14px',
                },
            },
        },
        '@keyframes ticker': {
            '0%': {
                transform: 'translate(0, 0)',
                visibility: 'visible',
            },
            '100%': {
                transform: 'translate(-100%, 0)',
            },
        },
        ticker: {
            display: 'inline-block',
            height: '4rem',
            lineHeight: '4rem',
            whiteSpace: 'nowrap',
            paddingRight: '100%',
            boxSizing: 'content-box',
            willChange: 'transform',
            animation: `$ticker 30s linear infinite`,
        },
        stickerItem: {
            display: 'inline-block',
            fontSize: '2rem',
            color: 'white',
            verticalAlign: 'sub',
            fontWeight: 'bold',
        },
    };
});

export default useStyles;
